import { Field, NumericInput, RadioGroup, TextOutput } from 'Components/Core';
import { withInjectedProps } from 'Components/Core/InjectedPropsContext';
import { ListFieldSection, PageSection } from 'Components/Layout';
import { WorksheetAssociatedTestSection } from 'Components/Worksheets/Core';
import { IWorksheetComponent } from 'Components/Worksheets/Core/types';
import externalTestMethods from 'Components/Worksheets/ExternalTestMethods';
import { Guid } from 'Lib/Guid';
import React from 'react';
import { useSelector } from 'react-redux';

const Section: React.FC<IWorksheetComponent> = ({ createWorksheetSelector }) => {
  const labMoistureTaken = useSelector(
    createWorksheetSelector!('EmbeddedMoistureContent.IsLabMoistureContentTaken')
  ) as boolean;

  const importedFieldMoistureContentID = useSelector(
    createWorksheetSelector!('AssociatedLabMoistureContent.ImportedTest.Id')
  ) as Guid;
  return (
    <PageSection heading="Laboratory Moisture Content">
      <Field
        input={<RadioGroup />}
        label="Laboratory Moisture Content Taken"
        name="EmbeddedMoistureContent.IsLabMoistureContentTaken"
        options={[
          { label: 'Yes', value: true },
          { label: 'No', value: false },
        ]}
      />

      {labMoistureTaken && (
        <WorksheetAssociatedTestSection
          name="AssociatedLabMoistureContent"
          testType="Moisture Content"
          heading="Moisture Content Result"
          associatedTestModel={{
            autoImported: true,
            imported: {
              importedTestResults: (
                <ListFieldSection>
                  <Field input={<TextOutput />} name="LabMoistureContent" />
                </ListFieldSection>
              ),
              importModel: {
                Id: importedFieldMoistureContentID,
              },
            },
            external: {
              testMethods: [externalTestMethods.moistureContent.AS_1289_2_1_1],
              permitOtherTestMethods: false,
              externalTestResults: (
                <ListFieldSection>
                  <Field
                    input={<NumericInput />}
                    name="AssociatedLabMoistureContent.ExternalTest.Results.MoistureContentPercent"
                  />
                </ListFieldSection>
              ),
            },
          }}
        />
      )}
    </PageSection>
  );
};

const AsLaboratoryMoistureContent = withInjectedProps(Section);

export { AsLaboratoryMoistureContent };
export default AsLaboratoryMoistureContent;
